"use strict";

exports.__esModule = true;
exports.labelVariants = exports.h3Variants = exports.bodyVariants = void 0;

var _styledSystem = require("styled-system");

var h3Variants = (0, _styledSystem.variant)({
  variants: {
    bold: {
      fontSize: 6,
      fontWeight: 600,
      letterSpacing: 0.3,
      lineHeight: "30px"
    }
  }
});
exports.h3Variants = h3Variants;
var labelVariants = (0, _styledSystem.variant)({
  variants: {
    large: {
      fontSize: 2,
      fontWeight: 400,
      letterSpacing: [1.5, 1.5, 4],
      lineHeight: "14px"
    }
  }
});
exports.labelVariants = labelVariants;
var bodyVariants = (0, _styledSystem.variant)({
  variants: {
    intro: {
      fontSize: [4, 4, 4, 4, 4, 5],
      fontWeight: 400,
      letterSpacing: 0.5,
      lineHeight: ["27px", "27px", "27px", "27px", "27px", "30px"]
    },
    legal: {
      fontSize: 1,
      fontWeight: 400,
      letterSpacing: 0.5,
      lineHeight: "15px"
    },
    metadata: {
      bold: {
        fontSize: 1,
        fontWeight: 600,
        letterSpacing: 0.5,
        lineHeight: "15px"
      },
      fontSize: 1,
      fontWeight: 400,
      letterSpacing: 0.5,
      lineHeight: "15px"
    },
    small: {
      fontSize: 2,
      fontWeight: 400,
      letterSpacing: 0.5,
      lineHeight: "18px"
    }
  }
});
exports.bodyVariants = bodyVariants;